module.exports = __webpack_public_path__ + "img/btn-arrow-prev.5ed6974b.png";